module.exports = __webpack_public_path__ + "img/1556906895.779a8595.jpg";